import React, { useEffect, useState, useCallback } from 'react';

import { Box, FormControl, FormLabel, RadioGroup, FormControlLabel, Radio, TextField, Grid } from '@mui/material';
import SendIcon from '@mui/icons-material/Send';
import DeleteOutlinedIcon from '@mui/icons-material/DeleteOutlined';
import { Document, Page, Text, StyleSheet, View, Image,PDFDownloadLink ,PDFViewer ,Font ,Svg } from '@react-pdf/renderer';
import { useGridApiRef,DataGrid } from '@mui/x-data-grid';
import Button from '@mui/material/Button';
import Checkbox from '@mui/material/Checkbox';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import CircularProgress from '@mui/material/CircularProgress';
import Backdrop from '@mui/material/Backdrop';
import Typography from '@mui/material/Typography';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Slide from '@mui/material/Slide';
import Tooltip from '@mui/material/Tooltip';
import Zoom from '@mui/material/Zoom';

import JsBarcode from 'jsbarcode';
import PrintQuantityCell from './PrintQuantityCell'; // 引入新組件
import chFont from '../../../css/font/TaipeiSansTCBeta-Bold.ttf'
import chLight from '../../../css/font/TaipeiSansTCBeta-Light.ttf'
import apiClient from '../ApiClient/ApiClient';



const Transition = React.forwardRef((props, ref) => <Slide direction="up" ref={ref} {...props} />);


export default function Inspection({data}) {
    const [loading, setLoading] = useState(false);

    const [rows,setRows] = React.useState([]);
    const [print,setPrint] = React.useState(false);
    const [checkPrint,setCheckPrint] = React.useState(false);
    const [expectedRows, setExpectedRows] = useState([]);
    const [filter,setFilter] = React.useState('');
    const [filterValue,setFilterValue] = React.useState('');
    const [open, setOpen] = React.useState(false);
    const [sendRow,setSendRow] = React.useState(null);
    const [orderNum,setOrderNum] = React.useState('');
    const [maxAmount,setMaxAmount] = React.useState(0);
    const [printItem,setPrintItem] = React.useState(null);
    const [printItems,setPrintItems] = React.useState([]);
    const [baseOrder64,setBaseOrder64] = React.useState('');
    const [basePinum64,setBasePinum64] = React.useState('');
    const [piNumCounts, setPinumCounts] = React.useState([]);
    const [dataCleared, setDataCleared] = React.useState(false);
    const [barCode, setBarCode] = useState('');
    
    const countPiNUms = (items) => {
        // 使用 reduce 函數來計算每個 ID 的出現次數
        const flatItems = items.flat();

        // 計算每個 id 的出現次數
        const countBypiNum = flatItems.reduce((acc, item) => {
            acc[item.piNum] = (acc[item.piNum] || 0) + 1;
            return acc;
        }, {});
        
        // 將物件轉換成陣列形式
        const resultArray = Object.entries(countBypiNum).map(([piNum, count]) => ({
            piNum, // 將鍵值轉換回數字類型，因為物件的鍵在 JavaScript 中是字串形式
            count
        }));
        
        return resultArray;
    }

    const generateBarcodes = (value, setValue) => {
    setLoading(true);
    const canvas = document.createElement('canvas');
    try {
        JsBarcode(canvas, value, {
            format: 'CODE128',
            displayValue: false,
        });
        setValue(canvas.toDataURL('image/png'));
    } catch (error) {
        console.error("Barcode generation failed:", error);
    }finally{
        setLoading(false);
    }
};


    const handleDeleteReOrder = async(row) => {
        setLoading(true);
        try {
            const response= await apiClient.post(`/Inspection/DeleteReserveOrder`, row, {
                params: {
                    UserName: sessionStorage.getItem('userName')
                }
            });
        
            if (response.data.statusCode === 200) {
              alert('成功');
              setExpectedRows(response.data.reservationOrders)
              setRows(response.data.orders)
              // 可以在这里添加其他成功的处理逻辑
              const updatedPrintItems = printItems.map(subArray =>
                subArray.filter(item => item.id !== row.id)
            );

            

            // 其他逻辑
            setExpectedRows(response.data.reservationOrders);
            setRows(response.data.orders);

            } else {
              alert('失败');
            }
          } catch (error) {
            console.error('Failed to add data:', error);
            alert('失败');
          }finally{
            setLoading(false);
          }
    };

    const SaveAll = async () => {
        setLoading(true);
        try {

            const rowsWithoutPrintQuantity = expectedRows.map(row => {
                const { printQuantity,itemIndex, ...rest } = row; // 使用解構賦值來排除 PrintQuantity
                return rest; // 回傳不包含 PrintQuantity 的新物件
            });
            console.log(rowsWithoutPrintQuantity);
            // 发送批量删除请求到服务器，传递 expectedrows 内的所有行数据
            const response = await apiClient.post(
                `/Inspection/DeleteAllReserveOrder`,
                rowsWithoutPrintQuantity, // 主體資料
                {
                    params: {
                        UserName: sessionStorage.getItem('userName'), // 查詢參數
                    },
                }
            );
            if (response.data.statusCode === 200) {
                // 如果服务器删除成功，则清空本地状态
                setExpectedRows([]);  // 清空 expectedrows
                // setRows([]);          // 清空 rows 或者 data，取决于你显示的是什么
                setDataCleared(true); // 标记数据已经清空
                alert('資料已清除');
            } else {
                alert('刪除失敗');
            }
        } catch (error) {
            console.error('Failed to delete all data:', error);
            alert('刪除失敗');
        }finally{
            setLoading(false);
        }
    };
    

    const handleSelectAll =async() => {
        setLoading(true);
        let url = '';
        switch (filter) {
            case '批號':
              url = `/Inspection/GetExpecteds?piNum=${filterValue}&UserName=${sessionStorage.getItem('userName')}`;
              break;
            case '圖號':
                url =  `/Inspection/GetExpecteds?drawNum=${filterValue}&UserName=${sessionStorage.getItem('userName')}`;
              break;
            
            default:
                alert('使用此功能需要選擇批號或圖號');   
            }  

        try {
            const response= await apiClient.post(url);
            if (response.status === 200) {
                const updatedReservationOrders = response.data.reservationOrders.map((order,index) => ({
                    ...order, // 保留订单对象的其他属性
                    printQuantity: 2, // 设置 printQuantity 的默认值，可以根据需求调整
                    itemIndex: index + 1,
                    }));
                // 将更新后的数组设置给 setExpectedRows
                setExpectedRows(updatedReservationOrders);
                // serchOrder();  // 更新页面数据
            } else {
              alert('查詢失败');
            }
          } catch (error) {
            console.error('Failed to add data:', error);
            alert('查詢失败');
          }finally{
            setLoading(false);
          }
    };
    
    const handlePrintClickOpen = (row) => {   
        console.log(printItems); 
        setPrint(true);
    };
    
      const handleClose = () => {
        setPrint(false);
        
    };
    
    const handleDialogOpen = (params, event, details) => {
        // 设置 sendRow 为当前选中的行
        setSendRow(params.row);
    
        // 设置 maxAmount 为选中行的 '未印' 字段值
        setMaxAmount(params.row.未印);
        
        // 可选：设置订单号（如果需要在对话框中显示）
        setOrderNum(params.row.orderNum);
        
        // 打开对话框
        setOpen(true);
        
        // 将选中的行添加到 expectedRows（根据您的业务逻辑）
        // setExpectedRows(prevRows => [...prevRows, params.row]);
        
        // 从 rows 中移除该行
        setRows(prevRows => prevRows.filter(row => row.id !== params.row.id));
    };
    


    const sendOrder = async (row) => {
        // const data = row || sendRow;  // 使用传入的 row 或者 sendRow
        if (!sendRow) {
            alert('沒有選中的訂單');
            return;
        }
    
        // 将 maxAmount 和 未印 转换为数字，以确保比较正确
        const maxAmountNum = Number(maxAmount);
        const 未印Num = Number(sendRow.未印);
    
        // 检查 maxAmount 是否不超过 未印
        if (Number.isNaN(maxAmountNum) || Number.isNaN(未印Num)) {
            alert('數量格式不正確');
            return;
        }
    
        if (maxAmountNum > 未印Num) {
            alert('最大数量不能超过未印的数量');
            return; // 终止函数，不进行 API 调用
        }
    
        // 设置 expectedAmount 为 maxAmount
        const dataToSend = {
            ...sendRow,
            expectedAmount: maxAmountNum, // 使用 maxAmount 作为预交货量
        };

        const postData = {
            company: sendRow.承製公司,
            client: sendRow.客戶,
            piNum: sendRow.批號,
            drawNum: sendRow.圖號,
            itemNum: sendRow.項次,
            itemName: sendRow.物品名,
            orderNum: sendRow.訂單號碼,
            orderSerial: sendRow.流水號,
            orderAmount: Number(sendRow.訂單數量),
            orderUnitPrice: Number(sendRow.訂購單價),
            expectedAmount: maxAmountNum,      // 用你的 maxAmount
            unit: sendRow.單位,
            launchAmount: sendRow.發動數量 ? Number(sendRow.發動數量) : undefined,
            inspectionOK: !!sendRow.檢票OK,
            clientDate: sendRow.客戶納期,
            accumulation: sendRow.累積交貨 ? Number(sendRow.累積交貨) : undefined,
            notYet: sendRow.未印 ? Number(sendRow.未印) : undefined,
            tradeLocation: sendRow.交貨地點,
            tureTradeDate: sendRow.實際交貨日,
            expectedTradeDate: sendRow.預計交貨日,
            introduce: sendRow.說明,
            markNum: sendRow.註記代號,
            price: sendRow.單價,
            receiveDate: sendRow.接收日期,
            model: sendRow.機種,
            stockLocation: sendRow.倉儲位址,
            qty: sendRow.qty,
            id: sendRow.id
        };
        // dataToSend 原傳送資料
        setLoading(true);
        try {
            const response = await apiClient.post(`/Inspection/ReserveOrders`, postData, {      
                params: {
                    UserName: sessionStorage.getItem('userName')
                }
            });
            if (response.data.statusCode === 200) {
                console.log(response.data);
                // 使用 map 遍历 reservationOrders 并添加 printQuantity 字段
                const updatedReservationOrders = response.data.reservationOrders.map((order,index) => ({
                    ...order, // 保留订单对象的其他属性
                    printQuantity: 2, // 设置 printQuantity 的默认值，可以根据需求调整
                    itemIndex: index + 1,
                    }));
                // 将更新后的数组设置给 setExpectedRows
                setExpectedRows(prevRows => [
                    ...prevRows, // 保留原有的資料
                    ...updatedReservationOrders // 添加新的資料
                ]);
                // serchOrder();  // 更新页面数据
            } else {
                alert(response.data?.message || '添加失败');
            }
            setOpen(false);
        } catch (error) {
            console.error('Failed to add data:', error);
            alert(error.response?.data?.message || '添加失败');
        }finally{
            setLoading(false);
        }
    };

    const serchOrder =async() => {
        setLoading(true);
        let url = '';
        switch (filter) {
            case '批號':
              url = `/Inspection/GetNewOrders?piNum=${filterValue}`;
              break;
            case '圖號':
                url =  `/Inspection/GetNewOrders?drawNum=${filterValue}`;
              break;
            case '訂單號碼':
                url =  `/Inspection/GetNewOrders?orderNum=${filterValue}`;
              break;
            default:
                url =  `/Inspection/GetNewOrders`;   
            }  

        try {
            const response= await apiClient.get(url);
            if (response.status === 200) {
              setRows(response.data)
            } else {
              alert('查詢失败');
            }
          } catch (error) {
            console.error('Failed to add data:', error);
            alert('查詢失败');
          }finally{
            setLoading(false);
          }
    };

    const getoldorder =async() => {
            setLoading(true);
            try {
                const response = await apiClient.get(`/Inspection/ReserveOldOrders?UserName=${sessionStorage.getItem('userName')}&OrderNum=${barCode}`);
                if (response.data.statusCode === 200) {
                    console.log(response.data);
                    // 使用 map 遍历 reservationOrders 并添加 printQuantity 字段
                    const updatedReservationOrders = response.data.reservationOrders.map((order,index) => ({
                        ...order, // 保留订单对象的其他属性
                        printQuantity: 2, // 设置 printQuantity 的默认值，可以根据需求调整
                        itemIndex: index + 1,
                        }));
                    // 将更新后的数组设置给 setExpectedRows
                    setExpectedRows(prevRows => [
                        ...prevRows, // 保留原有的資料
                        ...updatedReservationOrders // 添加新的資料
                    ]);
                    // serchOrder();  // 更新页面数据
                } else {
                    alert('添加失败');
                }
                setOpen(false);
            } catch (error) {
                console.error('Failed to add data:', error);
                alert('添加失败');
            }finally{
                setLoading(false);
            }
            
    };

    const handleSetPrintQuantity = async () => {
        setLoading(true);
        try {
            console.log("開始處理 expectedRows:", expectedRows);
            // 使用 Promise.all 來處理 expectedRows 中的每一行
            const updatedRows = await Promise.all(expectedRows.map(async (row) => {
                let order64;
                let piNum64;
    
                // 生成 order64 條碼
                await new Promise((resolve) => {
                    generateBarcodes(row.orderNum + row.orderSerial, (barcode) => {
                        order64 = barcode;
                        resolve();
                    });
                });
    
                // 生成 piNum64 條碼
                await new Promise((resolve) => {
                    generateBarcodes(row.piNum, (barcode) => {
                        piNum64 = barcode;
                        resolve();
                    });
                });
    
                // 返回新的 row 對象，包含新增的 order64 和 piNum64 字段
                return {
                    ...row,
                    order64,
                    piNum64,
                };
            }));
    
            // 按照 drawNum (圖號) 字段進行排序
            const sortedRows = updatedRows.sort((a, b) => {
                if (a.drawNum < b.drawNum) return -1;
                if (a.drawNum > b.drawNum) return 1;
                return 0;
             });
    
            // 根據 printQuantity 次數處理每一筆數據
            const newPrintItems = [...printItems]; // 創建 printItems 的副本
    
            sortedRows.forEach((row) => {
                const rowCopies = Array(row.printQuantity).fill(row); // 根據 printQuantity 創建 row 的副本數組
    
                rowCopies.forEach((copy) => {
                    if (newPrintItems.length === 0 || !Array.isArray(newPrintItems[newPrintItems.length - 1])) {
                        newPrintItems.push([copy]); // 在數組中新增一個子數組
                    } else if (newPrintItems[newPrintItems.length - 1].length === 6) {
                        newPrintItems.push([copy]); // 如果最後一個子數組已有6個元素，則新增一個子數組
                    } else {
                        newPrintItems[newPrintItems.length - 1].push(copy); // 否則，將 copy 添加到最後一個子數組中
                    }
                });
            });
    
            // 設置 printItem 為平鋪的 rowCopies 數組
            setPrintItem(newPrintItems.flat());
    
            // 更新 printItems
            setPrintItems(newPrintItems);
            alert('設定完成');
            console.log('Updated Print Items:', newPrintItems);
            handlePrintClickOpen();
        } catch (error) {
            console.error('Error in handleSetPrintQuantity:', error);
        }finally{
            setLoading(false);
        }
    };
    
    const handlePrintQuantityChange = useCallback((id, value) => {
        if (!Number.isNaN(value)) {
            console.log(`Updating printQuantity for id ${id} to ${value}`); // 调试日志
            setExpectedRows((prevRows) =>
                prevRows.map((row) => {
                    if (row.id === id) {

                        const updatedRow = { ...row, printQuantity: value };
                        return updatedRow;
                    }
                    return row;
                })
            );
        }
    }, []);
    
    const handlePrint = async () => {
        setLoading(true);
        try {
            const response = await apiClient.post(`/Inspection/PreparePrintData`, expectedRows, {
                params: { UserName: sessionStorage.getItem('userName') }
            });
    
            const preparedData = response.data;
            setPrintItem(preparedData.flat());
            setPrintItems(preparedData);
            setPrint(true);
        } catch (error) {
            alert("資料處理失敗");
        } finally {
            setLoading(false);
        }
    };
    
    
    

    const handleCheckPrint = async(trueOrfalse) => {
        if(trueOrfalse) {
            setLoading(true);
            try {
                const rowsWithoutPrintQuantity = expectedRows.map(row => {
                    const { printQuantity,itemIndex, ...rest } = row; // 使用解構賦值來排除 PrintQuantity
                    return rest; // 回傳不包含 PrintQuantity 的新物件
                });
                console.log(rowsWithoutPrintQuantity);
                const response = await apiClient.post(
                    `/Inspection/ResetReserveOrder`,
                    rowsWithoutPrintQuantity, // 主體資料
                    {
                        params: {
                            UserName: sessionStorage.getItem('userName') // 自定義標頭
                        }
                    }
                );
                
            
                if (response.data.statusCode === 200) {
                  alert('成功');
                  
                  setRows(response.data.orders)
                  // 可以在这里添加其他成功的处理逻辑
                } else {
                  alert('失败');
                }
              } catch (error) {
                console.error('Failed to add data:', error);
                alert('失败');
              }
            setCheckPrint(false);
            setPrintItem([]);
            setPrintItems([]);
        } else {
            setCheckPrint(false);
            setPrintItem([]);
            setPrintItems([]);
        }
        setLoading(false);
    }

    React.useEffect(() => {
        if (data && data.orders) {
            setRows(data.orders);
        }
        }, [data]);



    // React.useEffect(() => {
        // setPinumCounts(countPiNUms(printItems));
        // }, [printItems]);

    React.useEffect(() => {
         const fetchData = async () => {
            setLoading(true);
            try 
            {
                const response = await apiClient.get(`/Inspection/GetReserveOrders?UserName=${sessionStorage.getItem('userName')}`);
                if (response.data.reservationOrders != null) {
                  const ordersWithDefaults = response.data.reservationOrders.map((order,index) => ({
                    ...order,
                    expectedAmount: order.expectedAmount ?? order.orderAmount,
                    printQuantity: Number(order.printQuantity) || 2,
                    itemIndex: index + 1,
                    }));
                  setExpectedRows(ordersWithDefaults);
                } else 
                {
                  alert('数据加载失败');
                }
            } 
            catch (error) 
            {
                console.error('获取数据失败:', error);
                alert('数据加载失败');
            }finally{
                setLoading(false);
            }
            };
        
        fetchData();
    }, []);

    useEffect(() => {
        setExpectedRows(prevRows => {
            const updatedRows = prevRows.map((row, index) => {
                // 檢查 itemIndex 是否需要更新
                if (row.itemIndex !== index + 1) {
                    return { ...row, itemIndex: index + 1 };
                }
                return row;
            });

            // 檢查是否有任何變化
            const isDifferent = updatedRows.some((row, index) => row.itemIndex !== prevRows[index].itemIndex);

            // 如果有變化，則更新狀態
            if (isDifferent) {
                return updatedRows;
            }

            // 如果沒有變化，返回原來的狀態以避免無限循環
            return prevRows;
        });
    }, [expectedRows]);


    const columns = [
    
    {
        field: '客戶',
        headerName: '客戶',
        width: 80,
        editable: false,
    },
    {
        field: '批號',
        headerName: '批號',
        width: 120,
        editable: false,
    },
    {
        field: '訂單號碼',
        headerName: '訂單號碼',
        width: 120,
        editable: false,
    },
    {
        field: '流水號',
        headerName: '流水號',
        sortable: false,
        width: 60,
        editable: false,
    },
    {
        field: '訂購單價',
        headerName: '訂購單價',
        type:'number',
        sortable: true,
        width: 120,
        editable: false,
    },
    {
        field: '訂單數量',
        headerName: '訂單數量',
        type:'number',
        sortable: false,
        width: 100,
        editable: false,
    },
    {
        field: '未印',
        headerName: '未印',
        sortable: false,
        type:'number',
        width: 80,
        editable: false,
    },
    {
        field: '圖號',
        headerName: '圖號',
        sortable: false,
        width: 120,
        editable: false,
    },
    {
        field: '項次',
        headerName: '項次',
        sortable: false,
        width: 60,
        editable: false,
    },
    {
        field: '物品名',
        headerName: '物品名',
        sortable: false,
        width: 110,
        editable: false,
    },
    {
        field: '承製公司',
        headerName: '承製公司',
        sortable: false,
        width: 160,
        editable: false,
    },
    {
        field: '客戶納期',
        headerName: '客戶納期',
        sortable: false,
        width: 160,
        editable: false,
    },
    
    { field: 'id', headerName: 'ID', width: 90 },
    {
        field: '檢票OK',
        headerName: '檢票OK',
        width: 160,
        editable: true,
        renderCell: (params) => (
            <Checkbox
            checked={params.value}
            color="primary"
            inputProps={{ 'aria-label': 'secondary checkbox' }}
            onChange={() => {
                const newRows = rows.map(row => {
                if (row.id === params.id) {
                    return { ...row, inspectionOK: !params.value };
                }
                return row;
                });
                setRows(newRows);
            }}
            />
        ),
    },

    ];
    const detailColumns = [
        {
            field: 'itemIndex',
            headerName: '項次',
            width: 80,
            editable: false, // 不允許編輯
            sortable: true,  // 可選：是否允許排序
            align: 'center', // 水平對齊方式
        },
    
        {
            field: 'delete',
            headerName: '刪除',
            width: 80,
            editable: false,
            renderCell: (params) => (
              <Button startIcon={<DeleteOutlinedIcon />}
                onClick={() => handleDeleteReOrder(params.row)}
              >
               刪除
              </Button>
            ),
        },
        {
            field: 'piNum',
            headerName: '批號',
            width: 110,
            editable: false,
        },
        {
            field: 'orderNum',
            headerName: '訂單號碼',
            width: 110,
            editable: false,
        },
        {
            field: 'model',
            headerName: '機種',
            width: 140,
            editable: true, // 设为可编辑
        },
        {
            field: 'drawNum',
            headerName: '圖號',
            sortable: true,
            width: 140,
            editable: false,
            headerAlign: 'center',
            align: 'center',
            headerClassName: 'custom-header', // 自訂標題類名
            cellClassName: 'custom-cell',     // 自訂儲存格類名
        },
        {
            field: 'itemName',
            headerName: '品名',
            sortable: true,
            width: 120,
            editable: false,
        },
        
        {
            field: 'orderAmount',
            headerName: '訂單量',
            sortable: false,
            width: 70,
            editable: false,
        },
        {
            field: 'expectedAmount',
            headerName: '預交貨量',
            sortable: false,
            width: 90,
            editable: true, // 设置为不可编辑
            // 移除 renderCell
        },
        {
            field: 'printQuantity',
            headerName: '列印数量',
            width: 100,
            editable: true,
            type: 'number',
            renderCell: (params) => 
            (
                <PrintQuantityCell
                    id={params.row.id}
                    value={params.value }
                    handlePrintQuantityChange={handlePrintQuantityChange}
                />
            )
        },
        {
            field: 'expectedTradeDate',
            headerName: '交貨日期',
            sortable: false,
            width: 100,
            editable: false,
        },
        
        { field: 'id', headerName: 'ID', width: 90 }
        
    ];

    const processRowUpdate = (newRow, oldRow) => {
        // 验证 model 字段是否为空
        

        // 更新 expectedRows 状态
        setExpectedRows((prevRows) =>
            prevRows.map((row) => (row.id === newRow.id ? newRow : row))
        );

        return newRow;
    };

    return (
        <Box m={2}>
            
            <Backdrop
                sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={loading}
            >
                <CircularProgress color="inherit" />
            </Backdrop>

            <Grid container alignItems="center" spacing={0}>
                <Grid item xs={3}>
                    <FormControl component="fieldset">
                        <FormLabel id="demo-row-radio-buttons-group-label">過濾條件</FormLabel>                
                        <RadioGroup
                            row
                            aria-labelledby="demo-row-radio-buttons-group-label"
                            name="row-radio-buttons-group"
                            onChange={(e)=>setFilter(e.target.value)}
                        >
                            <FormControlLabel value="批號" control={<Radio />} 
                            label="批號" />
                            <FormControlLabel value="圖號" control={<Radio />} 
                            label="圖號" />
                            <FormControlLabel value="訂單號碼" control={<Radio />} 
                            label="訂單號碼" />
                        </RadioGroup>
                    </FormControl>
                </Grid>
                <Grid item xs={2}>
                    <TextField
                        required
                        id="outlined-required"
                        label="Required"
                        defaultValue=""
                        size="small"
                        onChange={(e) =>setFilterValue(e.target.value)}
                    />
                </Grid>
                <Grid item xs={3}>
                    <Button variant="contained" endIcon={<SendIcon />} onClick={serchOrder}>
                        搜尋
                    </Button>
                    <Button variant="contained" endIcon={<SendIcon />} onClick={handleSelectAll}>
                        整批選取
                    </Button>
                </Grid>
                
            </Grid>
            <Box sx={{ height: 450, width: '90%'}}>
            <DataGrid
                rows={rows}
                columns={columns}
                initialState={{
                pagination: {
                    paginationModel: {
                    pageSize: 100,
                    },
                },
                }}
                onRowDoubleClick={(params,event,details)=>handleDialogOpen(params,event,details)}
                pageSizeOptions={[50,100]}
                disableRowSelectionOnClick
                rowHeight={32}
                headerHeight={32}
            />
            <Typography variant="h3" display="inline">預交貨訂單</Typography>
            <Grid container spacing={1} alignItems="center" style={{ display: 'inline-flex', marginLeft: '16px' }}>
                <Grid item>
                        <TextField id="outlined-basic" label="請輸入訂單號碼或條碼" variant="outlined"
                        value={barCode} onChange={(e) => setBarCode(e.target.value)} />
                </Grid>
                <Grid item>
                    <Button
                        variant="contained"
                        onClick={() => getoldorder()}
                    >
                        查詢
                    </Button>
                </Grid>
            </Grid>

            <Tooltip TransitionComponent={Zoom} title="Save">
                <Button onClick={()=>SaveAll(expectedRows)}>清除列印資料</Button>
                <Button onClick={handlePrint}>列印</Button>
                <Button onClick={() =>handleCheckPrint(true)}>儲存資料</Button>
            </Tooltip>
           
            <DataGrid
                rows={expectedRows}
                columns={detailColumns}
                initialState={{
                pagination: {
                    paginationModel: {
                    pageSize: 100,
                    },
                },
                }}
                       
                        pageSizeOptions={[100,400]}
                        disableRowSelectionOnClick
                        processRowUpdate={processRowUpdate} // 使用 processRowUpdate
                        experimentalFeatures={{ newEditingApi: true }} // 启用新编辑 API
                        onProcessRowUpdateError={(error) => {
                        console.error(error);
                        }}
                        rowHeight={32}
                        headerHeight={32}
            />
            <Dialog open={open} onClose={()=>setOpen(false)}>
                <DialogTitle>預交貨訂單數量確認</DialogTitle>
                <DialogContent>
                <DialogContentText>
                訂單號碼 {orderNum} 預交貨數量 (最大: {sendRow?.未印})
                </DialogContentText>
                <TextField
                    autoFocus
                    margin="dense"
                    id="name"
                    label="數量"
                    type="number" // 确保类型为 number
                    fullWidth
                    variant="standard"
                    defaultValue={maxAmount}
                    onChange={(e) => setMaxAmount(Number(e.target.value))}
                    inputProps={{ min: 0, max: sendRow?.未印 }}
                />
                </DialogContent>
                <DialogActions>
                <Button onClick={()=>setOpen(false)}>取消</Button>
                <Button onClick={sendOrder}>送出</Button>
                </DialogActions>
            </Dialog> 
            <Dialog
                fullScreen
                open={print}
                onClose={handleClose}
                TransitionComponent={Transition}
            >
                <AppBar sx={{ position: 'relative', backgroundColor: 'black' }}>
                <Toolbar>
                    <IconButton
                    edge="start"
                    color="inherit"
                    onClick={handleClose}
                    aria-label="close"
                    >
                    <CloseIcon />
                    </IconButton>
                    <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
                    列印預覽
                    </Typography>
                </Toolbar>             
                </AppBar>         
                <PDFViewer style={{ width: '100%', height: '100%' }}>
                    <MyDocument data={printItem} datas={printItems} />
                </PDFViewer>
            </Dialog> 



                <Dialog
                    open={checkPrint}
                    onClose={() =>handleCheckPrint(false)}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogTitle id="alert-dialog-title">
                    {"請問您剛剛是否有列印?"}
                    </DialogTitle>
                    <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        若有列印 請選擇是，會將該筆預交貨訂單刪除 並更改資料庫<br/>
                        若無列印 請選擇否，資料庫保持原樣
                    </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                    <Button onClick={() =>handleCheckPrint(true)}>已列印</Button>
                    <Button onClick={() =>handleCheckPrint(false)} autoFocus>
                        未列印
                    </Button>
                    </DialogActions>
                </Dialog>  
            </Box>
        </Box>
    );
}


Font.register({
    family: 'TaipeiSansTCBeta-Bold',
    src: chFont, // 使用您的实际路径
  });
Font.register({
family: 'TaipeiSansTCBeta-Light',
src: chLight, // 使用您的实际路径
});
  
const styles = StyleSheet.create({
    page: {
      flexDirection: 'row',
      flexWrap: 'wrap',
      padding: 10,
      backgroundColor: 'white',
    },
  
    // 每頁 6 張：1/2 寬 × 1/3 高
    section: {
      width: '50%',
      height: '33.33%',
      padding: 10,
      position: 'relative',
    },
  
    // 頂端日期（右上）
    headRowTop: {
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'flex-start',
      marginBottom: 2,
    },
    headNo: { fontFamily: 'TaipeiSansTCBeta-Bold', fontSize: 10 },
    headChange: { fontFamily: 'TaipeiSansTCBeta-Bold', fontSize: 10, textAlign: 'right' },
  
    // 主標題
    titleRow: { flexDirection: 'row', justifyContent: 'flex-start', marginBottom: 2 },
    titleText: { fontFamily: 'TaipeiSansTCBeta-Bold', fontSize: 12 },
  
    // 通用row
    row: { flexDirection: 'row', alignItems: 'center', marginTop: 2 },
    // label 固定寬，對齊 251017 排版
    colLabel: { width: 56, fontSize: 10, fontFamily: 'TaipeiSansTCBeta-Light' },
    colValue: { flexGrow: 1, flexShrink: 1, fontSize: 9, fontFamily: 'TaipeiSansTCBeta-Bold' },
    vendorValue: { flexGrow: 1, flexShrink: 1, fontSize: 8, fontFamily: 'TaipeiSansTCBeta-Bold' },
  
    // 料件（大字）—— 往下些、字再大一點
    partNo: {
      fontFamily: 'TaipeiSansTCBeta-Bold',
      fontSize: 14,
      marginTop: 4,
      marginBottom: 2,
    },
  
    // 訂單條碼區
    barcodeRow: { flexDirection: 'row', alignItems: 'center', marginTop: 6 },
    barcodeTextLeft: { width: 64, fontSize: 10, fontFamily: 'TaipeiSansTCBeta-Light' },
    barcodeBlock: { flexGrow: 1, alignItems: 'center' },
    // 條碼高度加大，接近 251017 的視覺
    barcodeImg: { width: '92%', height: 36, marginBottom: 2 },
    barcodeImgsm: { width: '92%', height: 24, marginBottom: 2 },
      // 條碼下方一列：左人眼碼、右存放位置
  barUnderRow: {
    width: '92%',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
  },

  barcodeHuman: { fontSize: 10, fontFamily: 'TaipeiSansTCBeta-Light' },
  storageInline: { flexDirection: 'row', alignItems: 'center' },
  storageLabel: { fontSize: 10, fontFamily: 'TaipeiSansTCBeta-Light', marginLeft: 8 },
  storageValue: { fontSize: 10, fontFamily: 'TaipeiSansTCBeta-Bold' },
    // 右側小框（存放位置 / 免檢）
    rightSmallBox: { width: 90, alignItems: 'center' },
  
    // 使用工單條碼（第二段）
    barcodeRow2: { flexDirection: 'row', alignItems: 'center', marginTop: 4 },
  
    // 左下 QR
    qrBox: { position: 'absolute', left: 10, bottom: 8, width: 60, height: 60 },
  
    // 右下角小資訊
    footRight: {
      position: 'absolute',
      right: 10,
      bottom: 8,
      fontSize: 10,
      fontFamily: 'TaipeiSansTCBeta-Light',
      textAlign: 'left'
    },
    // 底部整條列（固定在 section 底、左右分佈）
  bottomBar: {
    position: 'absolute',
    left: 10,
    right: 10,
    bottom: 8,
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
  },

  // 右側：三行小字
  footRightWrap: {
    position: 'absolute',
    left: '50%',
    bottom: 8,
    width: 110,
    alignItems: 'flex-start',
  },
  footRightLine: {
    fontSize: 10,
    fontFamily: 'TaipeiSansTCBeta-Light',
    textAlign: 'left',
    lineHeight: 1.25,
    marginBottom: 2,
  },
  twoColRow: {
    flexDirection: 'row',
    alignItems: 'flex-start',
    marginTop: 2,
  },
  colL: {              // 左半：對應「廠商、料件、品名、現場位置」
    flexDirection: 'row',
    flexBasis: '68%',  // 可依需要微調 58~62%
    alignItems: 'center',
  },
  colR: {              // 右半：對應「交貨日 / 訂單數量 / 交貨數量 / 倉庫」
    flexDirection: 'row',
    flexBasis: '32%',
    alignItems: 'center',
    paddingLeft: 4,    // 讓左右欄有一點分隔
  },
  rLabel: { width: 50, fontSize: 10, fontFamily: 'TaipeiSansTCBeta-Light' }, // 跟交貨日用同寬
  rValue: { fontSize: 10, fontFamily: 'TaipeiSansTCBeta-Bold', flexShrink: 1 },

  // 讓第二支條碼的人眼字串下方多一行空白
  barcodeHumanSecond: { fontSize: 10, fontFamily: 'TaipeiSansTCBeta-Bold', marginBottom: 8 },
   // 取代原本 qrBox，用一個容器包「標題 + QR」
   qrWrap: {
    position: 'absolute',
    left: 10,
    bottom: 8,
    width: 70,
    alignItems: 'center',
  },
  qrTitle: {
    fontSize: 12,
    fontFamily: 'TaipeiSansTCBeta-Light',
    marginBottom: 2,
    textAlign: 'center',
  },
  qrImg: { width: 60, height: 60 },

  // 泛用空白行
  spacerSm: { height: 3 },
  });
  
  const MyDocument = ({ datas }) => {
    if (!datas || datas.length === 0) return <Text>沒有資料</Text>;
    const today = new Date();
    const ymdSlash = (d) =>
      `${d.getFullYear()}/${String(d.getMonth() + 1).padStart(2, '0')}/${String(d.getDate()).padStart(2, '0')}`;
    const loginCompany = (sessionStorage.getItem('company') || '').trim().toUpperCase();
    const companyDisplayNames = {
      HC: '華辰企業股份有限公司',
      FM: '福蒙精密工業股份有限公司',
    };
    const companyDisplayName = companyDisplayNames[loginCompany] || '';
  
    return (
      <Document>
        {datas.map((details, pageIndex) => (
          <Page size="A4" style={styles.page} key={pageIndex}>
            {details.map((data, idx) => (
              <View style={styles.section} key={idx}>
                {/* 右上日期 */}
                <View style={styles.headRowTop}>
                  <Text style={styles.headNo}>{/* NO. 可視需要填 */}</Text>
                  <Text style={styles.headChange}>{ymdSlash(today)}</Text>
                </View>
  
                {/* 主標題 */}
                <View style={styles.titleRow}>
                  <Text style={styles.titleText}>台灣博世舒適科技股份有限公司交貨現品票</Text>
                </View>
  
                {/* 左右兩欄：第一排 → 廠商 / 交貨日 */}
<View style={styles.twoColRow}>
  <View style={styles.colL}>
    <Text style={styles.colLabel}>廠商名稱：</Text>
    <Text style={styles.vendorValue}>{companyDisplayName || data.com || '華辰企業股份有限公司'}</Text>
  </View>
  <View style={styles.colR}>
    <Text style={styles.rLabel}>交貨日：</Text>
    <Text style={styles.rLabel}>{data.clientDate}</Text>
  </View>
</View>

{/* 第二排 → 料件 / 訂單數量（右欄與rLabel上排的交貨日對齊） */}
<View style={[styles.twoColRow, { marginTop: 4 }]}>
  <View style={styles.colL}>
    <Text style={styles.colLabel}>料件：</Text>
    <Text style={[styles.colValue, styles.partNo]}>{data.drawNum}</Text>
  </View>
  <View style={styles.colR}>
    <Text style={styles.rLabel}>訂單數量：</Text>
    <Text style={styles.rValue}>{data.orderAmount}</Text>
  </View>
</View>

{/* 第三排 → 品名 / 交貨數量（右欄與交貨日同起點） */}
<View style={styles.twoColRow}>
  <View style={styles.colL}>
    <Text style={styles.colLabel}>品名：</Text>
    <Text style={[styles.colValue, styles.partNo]}>{data.itemName}</Text>
  </View>
  <View style={styles.colR}>
    <Text style={styles.rLabel}>交貨數量：</Text>
    <Text style={styles.rValue}>{data.expectedAmount}</Text>
  </View>
</View>

{/* 第四排 → 現場位置 / 倉庫（右欄與交貨日同起點） */}
<View style={styles.twoColRow}>
  <View style={styles.colL}>
    <Text style={styles.colLabel}>現場位置：</Text>
    <Text style={styles.colValue}>{data.onsiteLocation}</Text>
  </View>
  <View style={styles.colR}>
    <Text style={styles.rLabel}>倉庫：</Text>
    <Text style={styles.rValue}>{data.warehouseAddress}</Text>
  </View>
</View>
  

                {/* 訂單號碼條碼（中） + 右側存放位置（方框） */}
                <View style={[styles.barcodeRow, { marginTop: 6 }]}>
  <Text style={styles.barcodeTextLeft}>訂單號碼：</Text>
  <View style={styles.barcodeBlock}>
    <Image style={styles.barcodeImgsm} src={data.order64} />
    {/* 條碼下方一列：左人眼碼、右存放位置 */}
    <View style={styles.barUnderRow}>
      <Text style={styles.barcodeHuman}>{`${data.orderNum}${data.orderSerial}`}</Text>
      <View style={styles.storageInline}>
        <Text style={styles.storageLabel}>存放位置：</Text>
        <Text style={styles.storageValue}>{data.storageLocation}</Text>
      </View>
    </View>
  </View>
</View>
  

  
                {/* 使用工單條碼（第二條碼） */}
<View style={styles.barcodeRow2}>
  <Text style={styles.barcodeTextLeft}>使用工單：</Text>
  <View style={styles.barcodeBlock}>
    <Image style={styles.barcodeImgsm} src={data.piNum64} />
    {/* 這裡改用 barcodeHumanSecond，內建 marginBottom */}
    <Text style={styles.barcodeHumanSecond}>{data.piNum}</Text>
  </View>
</View>

                {/* 右側「免檢」獨立靠右 */}
                <View style={[styles.barcodeRow, { marginTop: 2 }]}>
                  <View style={{ flexGrow: 1 }} />
                  <View style={styles.rightSmallBox}>
                    <Text style={[styles.colValue, { textAlign: 'center' }]}>{data.exemptfromInspection ? '免檢' : ''}</Text>
                  </View>
                </View>
  
                
                {/* 左下 QRCode（新增） */}
                {data.qr64 && (
  <View style={styles.qrWrap}>
    <Text style={styles.qrTitle}>客戶名稱/訂單</Text>
    <Image style={styles.qrImg} src={data.qr64} />
  </View>
)}
  
                {/* 右：三行小字（永遠靠右、從右邊開始） */}
                <View style={styles.footRightWrap}>
                    <Text style={styles.footRightLine}>機種：{data.model ?? ''}</Text>
                    <Text style={styles.footRightLine}>客戶料件：{data.version ?? ''}</Text>
                    <Text style={styles.footRightLine}>使用專案：{''}</Text>
                    <Text style={styles.footRightLine}>圖號版本：{data.version ?? ''}</Text>
                </View>
              </View>
            ))}
          </Page>
        ))}
      </Document>
    );
  };
  
